import { defineStore } from 'pinia'

import backgroundTasksApi from '@/api/backgroundtasks'
import type { BackgroundTaskAttributes, IndexBackgroundTasks } from 'common'

const useBackgroundTasksStore = defineStore('backgroundtasks', {
  state: () => ({
    backgroundTasks: [] as IndexBackgroundTasks[],
    loading: false,
    results: [] as BackgroundTaskAttributes[]
  }),
  getters: {
    pending(): IndexBackgroundTasks[] {
      return this.backgroundTasks.filter((_) => _.status === 'pending')
    },
    queued(): IndexBackgroundTasks[] {
      return this.backgroundTasks.filter((_) => _.status === 'queued')
    }
  },
  actions: {
    async index() {
      this.loading = true
      try {
        this.backgroundTasks = await backgroundTasksApi.index()
        return this.backgroundTasks
      } finally {
        this.loading = false
      }
    },
    async poll() {
      // Update any background tasks that the user has.
      await this.index()

      // Run again after the `timeout` to check again if the user has more work queued up.
      const timeout = 5000 // 5 seconds
      if (this.pending.length > 0 || this.queued.length > 0) {
        setTimeout(this.poll, timeout)
      }
    },

    show: backgroundTasksApi.show
  }
})

export default useBackgroundTasksStore
